import { aggregationFns } from '@tanstack/react-table'

export const DataTableAggregationFns = { ...aggregationFns }
